import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";

// 共済契約申請書参照API
// API仕様書_契約者
import {
  IAPI_CON002_Request,
  IAPI_CON002_Response,
} from "../../../type/apiType";

// 帳票ダウンロードAPI
// API仕様書_共通
import {
  IAPI_COM005_Request,
  IAPI_COM005_Response,
} from "../../../type/apiType";

// 帳票作成状況取得
import {
  IAPI_COM009_Request,
  IAPI_COM009_Response,
} from "../../../type/apiType/index";

// 共済契約申請書参照API
// API仕様書_契約者
const httpAPI_CON002 = async (
  param: IAPI_CON002_Request
): Promise<IAPI_CON002_Response> => {
  let res = await http.post(ApiUrl.API_CON002, {
    ...param,
  });
  return res.data;
};

// 帳票ダウンロードAPI
// API仕様書_共通
const httpAPI_COM005 = async (
  param: IAPI_COM005_Request
): Promise<IAPI_COM005_Response> => {
  let res = await http.post(ApiUrl.API_COM005, {
    ...param,
  });
  return res.data;
};

// 帳票作成状況取得API
const httpAPI_COM009 = async (
  param: IAPI_COM009_Request
): Promise<IAPI_COM009_Response> => {
  let res = await http.post(ApiUrl.API_COM009, {
    ...param,
  });

  return res.data;
};

export { httpAPI_CON002, httpAPI_COM005, httpAPI_COM009 };
